<template>
  <div class="app typography__body2">
    <TheHeaderBeautyNail />

    <main class="app__main ui-scrollbar-primary">
      <slot />
    </main>

    <TheFooterBeautyNail />

    <TheCookie />
  </div>

  <LazyAuthRegistrationModal
    v-if="isModalOpen(MODAL.AuthRegistration)"
    :id="MODAL.AuthRegistration"
  />

  <LazyAuthLoginModal
    v-if="isModalOpen(SHARED_MODAL.AuthLogin)"
    :id="SHARED_MODAL.AuthLogin"
  />

  <LazyAuthPasswordNewModal
    v-if="isModalOpen(MODAL.AuthPasswordNew)"
    :id="MODAL.AuthPasswordNew"
  />

  <LazyAuthPasswordRemindModal
    v-if="isModalOpen(MODAL.AuthPasswordReset)"
    :id="MODAL.AuthPasswordReset"
  />
</template>

<script setup lang="ts">
defineSlots<{
  default: () => void;
}>();

const { isModalOpen } = useModalStore();

useHead({
  script: [
    {
      async: true,
      src: "//code.jivo.ru/widget/7Slof3XiwX",
    },
  ],
});
</script>

<style scoped>
.app {
  background-color: var(--grey-7);
}

@media (--desktop) {
  .app {
    display: grid;
  }
}

@media (--desktop) {
  .app__main {
    overflow: auto;
  }
}
</style>
